module.exports = __webpack_public_path__ + "static/media/borda_template.79d9a579.png";